import InfoIcon from '@mui/icons-material/Info';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import { IconButton, Typography } from '@mui/material';

const PuestoSquare = ({ mesa, puesto, isSeleccionado, onSelect }) => {
  const isHabilitado = puesto.habilitado;
  const isFree = puesto.status === 'FREE';
  const clickable = isHabilitado && isFree;

  const estado = !isHabilitado
    ? { icon: <BlockIcon fontSize="small" color="error" />, tip: 'No habilitado' }
    : !isFree
      ? { icon: <InfoIcon fontSize="small" color="warning" />, tip: 'Ocupado' }
      : { icon: <CheckCircleIcon fontSize="small" />, tip: 'Disponible' };

  return (
    <Tooltip title={estado.tip}>
      <span>
        <IconButton
          size="small"
          disabled={!clickable}
          onClick={() => onSelect(puesto, mesa)}
          sx={{
            width: 48,
            height: 48,
            flexDirection: 'column',
            bgcolor: isSeleccionado ? 'primary.light' : 'grey.100',
            border: 1,
            borderColor: isSeleccionado ? 'primary.main' : 'grey.300',
            opacity: clickable ? 1 : 0.5,
            // cursor: clickable ? 'pointer' : 'default'
          }}
        >
          <Typography variant="caption" fontSize={11}>
            #{puesto.id}
          </Typography>
          {estado.icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default PuestoSquare;